module.exports = __webpack_public_path__ + "img/10.9482ac4e.png";